import {DomainEvent} from './DomainEvent';
import {Club} from '../resources/Club';

export class ClubCreated extends DomainEvent<Club> {}
